import Fetch from '../fetch'

export default class UniverseModule extends Fetch {
    /**
     * @param {String} population Targeted population
     * @returns {AjaxObservable}
     */
    getConfig = (population) => this.getEmiConfig(population)
}
